export default __webpack_public_path__ + "static/media/stats4.8bfc92c8.png";